import React from 'react';
import { DeleteButton, EditButton } from '../buttons';
export default function TableControlsColumn(_ref) {
  let {
    originalTableRow,
    rowVirtualIndex,
    tableIsImmutableUnderReview,
    tableOnDelete,
    tableOnEdit,
    tableDisableDelete
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: 'text-end'
  }, originalTableRow.controls && /*#__PURE__*/React.createElement("div", null, originalTableRow.controls), !originalTableRow.controls && tableOnEdit && originalTableRow.showEdit !== false && /*#__PURE__*/React.createElement(EditButton, {
    isImmutableUnderReview: tableIsImmutableUnderReview,
    onClick: () => tableOnEdit(rowVirtualIndex, originalTableRow)
  }), !originalTableRow.controls && tableOnDelete && originalTableRow.showDelete !== false && /*#__PURE__*/React.createElement(DeleteButton, {
    isImmutableUnderReview: tableIsImmutableUnderReview,
    onClick: () => tableOnDelete(rowVirtualIndex, originalTableRow),
    disabled: tableDisableDelete
  }));
}